module.exports = __webpack_public_path__ + "static/media/whale.71556eeb.ogg";